(function () {
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("collection-with-filter-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initHeadingAnimation(event.target);
  });
})();


document.addEventListener('DOMContentLoaded', function () {

  const pills = document.querySelectorAll('.collection-with-filter--item');
  const groups = document.querySelectorAll('.collection-with-filter--collection-group');

  pills.forEach(pill => {
    pill.addEventListener('click', () => {

      const handle = pill.dataset.collection;

      // active pill
      pills.forEach(p => p.classList.remove('active'));
      pill.classList.add('active');

      // show correct collection
      groups.forEach(group => {
        if (group.dataset.collection === handle) {
          group.classList.add('active');
        } else {
          group.classList.remove('active');
        }
      });

    });
  });

});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.collection-with-filter--collection-group').forEach(group => {
    const container = group.querySelector('.popular-products-list');

    if (!container) return;

    container.classList.add('swiper');
    container.querySelectorAll('.popular-products-item').forEach(item => {
      item.classList.add('swiper-slide');
    });

    const wrapper = document.createElement('div');
    wrapper.classList.add('swiper-wrapper');

    const slides = Array.from(container.children);
    slides.forEach(slide => wrapper.appendChild(slide));

    container.appendChild(wrapper);

    new Swiper(container, {
      navigation: {
        nextEl: group.querySelector('.popular-products-nav-button--next'),
        prevEl: group.querySelector('.popular-products-nav-button--prev')
      },
      breakpoints: {
        576: { slidesPerView: 2.1, spaceBetween: 20 },
        990: { slidesPerView: 3.15, spaceBetween: 24 },
        1360: { slidesPerView: 4.15, spaceBetween: 24 },
      },
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      loop: false,
      centeredSlides: false,
      centeredSlidesBounds: false,
    });
  });
});